import React, { useState } from 'react';

const ContactForm = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // şimdilik sadece console.log
    console.log('Gönderilen:', form);
    alert("Mesajınız alındı, teşekkür ederiz!");
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <div style={{ backgroundColor: '#f5f5f5', padding: '80px 20px' }}>
      <h2 style={{
        textAlign: 'center',
        fontSize: '36px',
        marginBottom: '40px',
        color: '#333',
        fontWeight: '700'
      }}>
        Bize Ulaşın
      </h2>

      <form onSubmit={handleSubmit} style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        maxWidth: '700px',
        margin: '0 auto',
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        <input
          type="text"
          name="name"
          placeholder="Adınız"
          value={form.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          type="email"
          name="email"
          placeholder="E-posta adresiniz"
          value={form.email}
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <textarea
          name="message"
          placeholder="Mesajınız"
          value={form.message}
          onChange={handleChange}
          required
          rows="5"
          style={{ ...inputStyle, resize: 'vertical' }}
        />
        <button type="submit" style={buttonStyle}>
          Gönder
        </button><h4>destek@emlakvitrini.net</h4>
      </form>
      
    </div>
  );
};

const inputStyle = {
  padding: '14px',
  fontSize: '16px',
  borderRadius: '8px',
  border: '1px solid #ccc',
  outline: 'none'
};

const buttonStyle = {
  backgroundColor: '#4F75FF',
  color: 'white',
  border: 'none',
  padding: '14px',
  fontSize: '16px',
  borderRadius: '8px',
  cursor: 'pointer'
};

export default ContactForm;
